var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.section
    ? _c(
        "div",
        { staticClass: "flex flex-col items-center w-full gap-5" },
        [
          _c(
            "div",
            {
              staticClass:
                "flex flex-col w-full gap-2 px-4 py-5 border-l-8 lg:w-148 lg:px-10 bg-pure-white border-red-salmon rounded-xl",
              attrs: { id: "section_field_" + _vm.section.id }
            },
            [
              _c("BlTextSubtitle2", { attrs: { text: _vm.section.name } }),
              _vm._v(" "),
              _vm.section.description
                ? _c("BlTextBody2", {
                    staticClass: "whitespace-pre-line text-slate-800",
                    attrs: { text: _vm.section.description }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.section.questions, function(question) {
            return _c("ProspectFormQuestion", {
              key: question.id,
              attrs: { sectionId: _vm.section.id, question: question }
            })
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a75bf9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a75bf9e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/prospectForm/Section.vue
// module id = null
// module chunks = 